/*!
    * Start Bootstrap - SB Admin v7.0.7 (https://startbootstrap.com/template/sb-admin)
    * Copyright 2013-2023 Start Bootstrap
    * Licensed under MIT (https://github.com/StartBootstrap/startbootstrap-sb-admin/blob/master/LICENSE)
    */
    // 
// Scripts
// 

window.addEventListener('DOMContentLoaded', event => {

    // Toggle the side navigation
    const sidebarToggle = document.body.querySelector('#sidebarToggle');
    if (sidebarToggle) {
        // Uncomment Below to persist sidebar toggle between refreshes
        // if (localStorage.getItem('sb|sidebar-toggle') === 'true') {
        //     document.body.classList.toggle('sb-sidenav-toggled');
        // }
        sidebarToggle.addEventListener('click', event => {
            event.preventDefault();
            document.body.classList.toggle('sb-sidenav-toggled');
            localStorage.setItem('sb|sidebar-toggle', document.body.classList.contains('sb-sidenav-toggled'));
        });
    }

});


Check = {
    all: function (obj, chk_class) {
      $(chk_class).prop('checked', $(obj).is(':checked'))
    },
    validate: function () {
      if (!$('.chk-mensagem:checked').length) {
        toastr["warning"]("É necessário selecionar ao menos um registro para excluir.");
        return false;
      }
  
      confirmar("Deseja realmente excluir o(s) registro(s) selecionado(s)?", function () {
        $('#form-grid').submit();
      });
  
      return false;
    }
};

  